import { Controller } from "stimulus";

// Shows the select's chosen option label in each label target.
export default class extends Controller {
  static targets = ["select", "label"];

  connect() {
    this.render();
  }

  render() {
    const { text } = this.selectTarget.selectedOptions[0];

    this.labelTargets.forEach((label) => {
      label.textContent = text;
    });
  }
}
